<template>
    <div v-if="mostrarMenu" class="mt-2">
        <h4 class="heading-1">
            <span>SGTEC</span>
        </h4>
        <b-list-group>
            <relacao-etapas></relacao-etapas>
            <relacao-etapas-gestores></relacao-etapas-gestores>
            <relacao-etapas-gerentes></relacao-etapas-gerentes>
            <relacao-etapas-apoios></relacao-etapas-apoios>
            <relacao-etapas-cancelamento></relacao-etapas-cancelamento>
        </b-list-group>
    </div>
</template>

<script>
import RelacaoEtapas from '../uabs/relatorios/RelacaoEtapas'
import RelacaoEtapasCancelamento from '../uabs/relatorios/RelacaoEtapasCancelamento'
import RelacaoEtapasGestores from '../gestores/relatorios/RelacaoEtapas'
import RelacaoEtapasGerentes from '../gerentes/relatorios/RelacaoEtapas'
import RelacaoEtapasApoios from '../apoios/relatorios/RelacaoEtapas'

export default {
    components: {
        RelacaoEtapas,
        RelacaoEtapasGestores,
        RelacaoEtapasGerentes,
        RelacaoEtapasApoios,
        RelacaoEtapasCancelamento
    },

    computed: {
        mostrarMenu() {
            return this.$temAcessoView('SGTEC-REL-00')
        }
    }
}
</script>
